import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=11c13ca0&scoped=true"
import script from "./TwoFactor.vue?vue&type=script&lang=js"
export * from "./TwoFactor.vue?vue&type=script&lang=js"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=11c13ca0&prod&lang=css"
import style1 from "./TwoFactor.vue?vue&type=style&index=1&id=11c13ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c13ca0",
  null
  
)

export default component.exports